<div class="h-100 d-flex flex-column justify-content-between align-items-center step-list" [ngClass]="{'section-available': workflowSections, 'video-flow-available':isVideoFlow}">
  <div class="steps-manage-wrapper">
    @if (stepList.length && !isVideoFlow) {
      <div class="d-flex align-items-center justify-content-center fs-14 font-weight-600 manage-steps" (click)="selectModeChange()" [ngStyle]="{'pointer-events': type=='published' ? 'none' : ''}">
        <span class="me-1">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.MANAGE-STEPS.TITLE' | translate }}</span>
        @if (selectMode) {
          <img src="assets/img/expand_less.svg" alt="" class="less-icon">
        }
        @if (selectMode) {
          <img src="assets/img/expand_less_copy.svg" alt="" class="less-icon-hover">
        }
        @if (!selectMode) {
          <img src="assets/img/expand_more.svg" alt="" class="less-icon">
        }
        @if (!selectMode) {
          <img src="assets/img/expand_more_copy.svg" alt="" class="less-icon-hover">
        }
      </div>
    }

    @if (selectMode) {
      <div class="row w-100 ms-0" style="padding-inline: 3px;">
        <div class="col-3 step-opt-card" [dynamicTooltip]="('MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.MANAGE-STEPS.DELETE' | translate)" tooltipPosition="bottom" [tooltipDelay]="0">
          <div class="option-single-card">
            <button class="selected-step-options" (click) = "deleteSelectedSteps()"
              [disabled]="!selectedStepList?.length || selectedStepList?.length == 0" [ngStyle]="{'pointer-events': (!selectedStepList?.length || selectedStepList?.length == 0) ? 'none' : ''}">
              <div >
                <img src="assets/img/delete-step.svg" alt="" class="normal-icon">
                <img src="assets/img/delete-step-hover.svg" alt="" class="hover-icon">
              </div>
            </button>
          </div>
        </div>
        <div class="col-3 step-opt-card">
          <div class="option-single-card" [dynamicTooltip]="('MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.MANAGE-STEPS.DUPLICATE' | translate)" tooltipPosition="bottom" [tooltipDelay]="0">
            <button class="selected-step-options" (click) = "duplicateSelectedSteps()"
              [disabled]="!selectedStepList?.length || selectedStepList?.length == 0" [ngStyle]="{'pointer-events': (!selectedStepList?.length || selectedStepList?.length == 0) ? 'none' : ''}">
              <div >
                <img src="assets/img/duplicate-step.svg" alt="" class="normal-icon">
                <img src="assets/img/duplicate-step-hover.svg" alt="" class="hover-icon">
              </div>
            </button>
          </div>
        </div>
        <div class="col-3 step-opt-card">
          <div class="option-single-card" [dynamicTooltip]="('MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.MANAGE-STEPS.CLONE' | translate)" tooltipPosition="bottom" [tooltipDelay]="0">
            <button class="selected-step-options" (click) = "cloneSelectedSteps()"
              [disabled]="!selectedStepList?.length || selectedStepList?.length == 0" [ngStyle]="{'pointer-events': (!selectedStepList?.length || selectedStepList?.length == 0) ? 'none' : ''}">
              <div>
                <img src="assets/img/clone-step.svg" alt="" class="normal-icon">
                <img src="assets/img/clone-step-hover.svg" alt="" class="hover-icon">
              </div>
            </button>
          </div>
        </div>
        <div class="col-3 step-opt-card">
          <div class="option-single-card" [dynamicTooltip]="('MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.MANAGE-STEPS.MOVE' | translate)" tooltipPosition="bottom" [tooltipDelay]="0">
            <button class="selected-step-options" (click) = "moveSelectedSteps()"
              [disabled]="!selectedStepList?.length || selectedStepList?.length == 0" [ngStyle]="{'pointer-events': (!selectedStepList?.length || selectedStepList?.length == 0) ? 'none' : ''}">
              <div>
                <img src="assets/img/move-step.svg" alt="" class="normal-icon">
                <img src="assets/img/move-step-hover.svg" alt="" class="hover-icon">
              </div>
            </button>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="steps-wrapper w-100" #stepsWrapper cdkDropList (cdkDropListDropped)="drop($event)" (scroll)="onScrollStepList()" >
    @if (!stepList.length && !isVideoFlow) {
      <div class="d-flex flex-column" style="padding: 0.75rem;">
        <div class="rectangle d-flex">
          <div class="info-p">
            <img src="assets/img/info.svg">
          </div>
          <div class="inform-text">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.INFORM' | translate }}</div>
        </div>
      </div>
    }

    @if (selectMode) {
      <div class="step-select-options fs-14 font-weight-600">
        <div class="font-color-blue" (click)="selectAll()">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.MANAGE-STEPS.SELECT-ALL' | translate }}</div>
        <div class="font-color-blue" (click)="unselectAll()">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.MANAGE-STEPS.DESELECT-ALL' | translate }}</div>
      </div>
    }
    @for (step of stepList; track step; let index = $index) {
      <div class="d-flex flex column" style="position: relative;padding-bottom: 4px;" cdkDrag [cdkDragDisabled]="connectionEnabled || type=='published' || step.data.isSection">
        <div (click)="onSelectStep(step)" class="step-card" [class.selected]="step?.id === selectedStepId" [class.select-mode-active]="selectMode && step?.selectModeActive && !step.data.isSection" [class.d-none]="step['notShow'] || step?.data['parentWorkflow']">
          <div class="me-2 mb-1" [ngClass]="{'part-of-section':step.data.parentId}" [dynamicTooltip]="(connectionEnabled &&  !step.data.isSection) ? ('MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.MANAGE-STEPS.CONNECTION-VIEW-DISABLED' | translate) : null">
            @if (!step.data.isSection && !isVideoFlow) {
              <img class="handle" src="assets/img/step-drag.svg"  alt="" cdkDragHandle>
            }
            @if (step.data.isSection && !step['hide']) {
              <img src="assets/img/down-icon.svg" style="transform:rotate(360deg)"   (click)="handleSectionSteps(step)" alt="">
            }
            @if (step.data.isSection && step['hide']) {
              <img src="assets/img/down-icon.svg"  style="transform: rotate(270deg)" (click)="handleSectionSteps(step)" alt="">
            }
          </div>
          <div class="d-flex justify-content-between align-items-center">
            @if (!step?.data?.['editNameMode'] && !workflowTranslations) {
              <div class="fs-14 font-weight-400 step-text" [ngClass]="{'section':step.data.isSection}" title="{{step.data.name}}">{{step.data.name}}</div>
            }
            @if (!step?.data?.['editNameMode'] && workflowTranslations) {
              <div class="fs-14 font-weight-400 step-text" [ngClass]="{'section':step.data.isSection}" title="{{workflowTranslations[selectedLang][step.data.name]}}">{{workflowTranslations[selectedLang][step.data.name]}}</div>
            }
            @if (step?.data?.['editNameMode']) {
              <div>
                <input [inputSelectOnCreate]="true" type="text" class="title-input fs-14 font-weight-600" [formControl]="stepName" (keyup.enter)="updateName(step.data)" (blur)="updateName(step.data)">
                @if (stepName.errors?.['required']) {
                  <div class="validation-text mb-0 mt-0">
                    {{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.STEP.NO-NAME' | translate }}
                  </div>
                }
              </div>
            }
            @if (!step.valid) {
              <div [dynamicTooltip]="'Invalid Step'">
                <img src="assets/img/warning.svg" alt="" height="17px" width="17px">
              </div>
            }
            @if (type=='draft') {
              <div class="dropdown-wrapper" dropdown container="body">
                <a id="stepListStepOptionsButton{{step.id}}" class="btn btn-default name-wrapper" id="dropdownMenuLink" dropdownToggle aria-controls="dropdown-basic">
                  @if (!step.data?.['editNameMode'] && type=='draft') {
                    <img src="assets/img/more-grey.svg" alt="" height="26px">
                  }
                </a>
                <div #stepListStepOptions class="dropdown-menu" *dropdownMenu role="menu" aria-labelledby="dropdownMenuLink" [ngClass]="{'is-video-flow': isVideoFlow}">
                  @if (type=='draft') {
                    <div>
                      @if (step.data.isSection) {
                        <a class="dropdown-item fs-14" (click)="addStepToActivity(step)">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.STEP.ADD-STEP' | translate }}</a>
                      }
                      <a class="dropdown-item fs-14" (click)="rename(step.data)">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.STEP.OPTIONS.RENAME' | translate }}</a>
                      @if (!step.data.isSection && step.data.layouts[0]?.items[0].type !== 'workflow' && !isVideoFlow) {
                        <a class="dropdown-item fs-14" (click)="duplicateStep(step.data)">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.STEP.OPTIONS.DUPLICATE' | translate }}</a>
                      }
                      @if (!step.data.isSection && step.data.layouts[0]?.items[0].type !== 'workflow' && !isVideoFlow) {
                        <a class="dropdown-item fs-14" (click)="cloneStep(step.data,'clone')">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.STEP.OPTIONS.CLONE' | translate }}</a>
                      }
                      @if (!step.data.isSection && step.data.layouts[0]?.items[0].type !== 'workflow' && !isVideoFlow) {
                        <a class="dropdown-item fs-14" (click)="moveStep(step.data,step.id,'move')">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.STEP.OPTIONS.MOVE' | translate }}</a>
                      }
                      @if (!isVideoFlow) {
                        <a class="dropdown-item fs-14 text-red" (click)="deleteStep(index,step)">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.STEP.OPTIONS.DELETE' | translate }}</a>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  @if (!isVideoFlow) {
    <div class="text-center" style="position: absolute; bottom: 0; z-index: 500; background-color: white;width: 100%;">
      <div class="create-button-group">
        <button class="v-btn btn btn-primary m-2 vsight-button create-button step-create" (click)="createStep(true)" [disabled]="type=='published'" >{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.STEP.CREATE' | translate | titlecase }}</button>
        <div>
          @if (workflowSections) {
            <a class="change-layout-link fs-14 font-weight-600 cursor-pointer hover-underline" (click)="createSection()" [ngClass]="{'disabled-link': type=='published'}">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.STEP-LIST.CREATE-SECTION' | translate }}</a>
          }
        </div>
      </div>
    </div>
  }
</div>
